import ApiService from 'global/utils/ApiService';
import endpointUrls from 'global/Constants/endpointUrls';
import { setAllProvincesWithoutSearch } from 'redux/reducer/basicData/provinceReducer';
import { AppDispatch } from 'redux/store';

export const getAllProvinceWithoutSearch = () => async (dispatch: AppDispatch) => {
  await ApiService.post(endpointUrls.provinceGetAll, {})
    .then((res: any) => {
      res.isSuccess && dispatch(setAllProvincesWithoutSearch(res.data));
    })
    .catch(() => {});
};
